import { alpha } from '@mui/material/styles';
export const transportSelectedItemStyle = (theme) => ({
    width: '100%',
    height: 'calc(100% - 30px)',
    overflow: 'hidden',
    borderTop: '1px solid',
    borderColor: theme.palette.divider,
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: '2',
    '& > .MuiPaper-elevation:first-of-type': {
        width: '260px',
        borderRight: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: '0',
    },
    '& > .MuiPaper-elevation:last-of-type': {
        flex: 1,
        bgcolor: 'background.default',
        borderRadius: '0',
    },
});
export const scrollItemStyle = (theme) => ({
    gap: 2,
    padding: theme.spacing(2),
    '.MuiPaper-root': {
        position: 'relative',
        borderStyle: 'solid',
        marginTop: theme.spacing(4),
        borderRadius: theme.shape.borderRadius,
        borderColor: theme.palette.divider,
        '.MuiPaper-label': {
            position: 'absolute',
            top: theme.spacing(-4),
            left: theme.spacing(1),
            padding: theme.spacing(0, 1),
            fontWeight: '500',
            color: 'text.secondary',
            fontSize: '11px',
            textTransform: 'uppercase',
        },
    },
});
export const transportConditionItemsStyle = (theme) => ({
    height: '100%',
    overflow: 'hidden',
    borderTop: '1px solid',
    borderColor: theme.palette.divider,
    paddingBottom: '30px',
    '.MuiPaper-elevation:first-of-type': {
        minWidth: '160px',
        maxWidth: '160px',
        borderRight: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: '0',
        display: 'flex',
        flexDirection: 'column',
    },
    '.MuiPaper-elevation:last-of-type': {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        borderRadius: '0',
    },
});
export const transportConditionScrollItemStyle = (theme) => ({
    display: 'grid',
    gap: 1,
    padding: theme.spacing(2),
    '.MuiPaper-root': {
        position: 'relative',
        borderStyle: 'solid',
        padding: theme.spacing(2),
        paddingTop: theme.spacing(6),
        borderRadius: theme.shape.borderRadius,
        borderColor: theme.palette.divider,
        '.MuiPaper-label': {
            position: 'absolute',
            top: '10px',
            left: theme.spacing(1),
            padding: theme.spacing(0, 1),
            bgcolor: 'background.paper',
            fontWeight: '500',
            '&>:not(style)+:not(style)': {
                marginTop: theme.spacing(0),
            },
        },
        '.MuiPaper-row': {
            display: 'grid',
            gap: 1,
            gridTemplateColumns: 'repeat(3, 1fr)',
            '.MuiTypography-root:first-of-type': {
                color: 'text.secondary',
            },
        },
    },
});
export const gridColumnsStyle = (theme) => ({
    display: 'grid',
    gap: 1,
    gridTemplateColumns: 'repeat(7, 1fr)',
    marginTop: theme.spacing(0),
    '.MuiPaper-root:first-of-type': {
        gridRow: '1',
        gridColumn: '1/6',
        '.MuiPaper-row': {
            gridTemplateColumns: 'repeat(7, 1fr) !important',
            '.MuiTypography-root:first-of-type': {
                gridColumn: '1/2',
            },
            '.MuiTypography-root:last-of-type': {
                gridColumn: '2/8',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
        },
    },
    '.MuiPaper-root:last-of-type': {
        gridRow: '1',
        gridColumn: '6/8',
        '.MuiPaper-row': {
            '.MuiTypography-root:first-of-type': {
                gridColumn: '1/2',
            },
            '.MuiTypography-root:last-of-type': {
                gridColumn: '2/4',
            },
        },
    },
});
export const conditionOptionsStyle = (theme, transportSelectedItem) => {
    var _a;
    return ({
        '.MuiDivider-root': {
            margin: '2px 4px',
        },
        '.MuiButtonBase-root': Object.assign({ width: '24px', height: '24px', '&:hover': {
                color: theme.palette.primary.main,
            } }, (((_a = transportSelectedItem.conditionOptions) === null || _a === void 0 ? void 0 : _a.open) && {
            color: theme.palette.primary.main,
        })),
    });
};
export const lastRowStyle = (theme) => ({
    display: 'grid',
    gridTemplateColumns: '160px auto 38px',
    width: '100%',
    position: 'absolute',
    bottom: '0',
    height: '30px',
    bgcolor: 'background.paper',
    borderTop: '1px solid',
    borderColor: theme.palette.divider,
    '.MuiButton-root': {
        padding: '3px',
        height: 'auto',
        svg: {
            fontSize: '16px',
        },
    },
    '.MuiDivider-root': {
        margin: '2px 6px',
    },
});
export const canStyle = (theme, transportConditionSelectedItem) => ({
    display: 'grid',
    gap: 1,
    gridTemplateColumns: 'repeat(1, 1fr)',
    marginTop: `${theme.spacing(0)}!important`,
    '.MuiPaper-root': {
        display: 'grid',
        gap: 1,
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '.MuiPaper-label': {
        display: 'flex',
        alignItems: 'center',
        svg: Object.assign({ fontSize: '18px', position: 'absolute', top: '-2px', right: '-18px', color: theme.palette.text.secondary }, (transportConditionSelectedItem.data.acc_status !== config.conditions.acc_status.default &&
            transportConditionSelectedItem.data.acc_status !== 0 && {
            color: theme.palette.primary.main,
        })),
    },
    '.MuiPaper-row .MuiTypography-root:first-of-type': {
        gridColumn: '1/3',
    },
    '.MuiPaper-row .MuiTypography-root:last-of-type': {
        gridColumn: '3/3',
        'span:nth-of-type(2)': {
            paddingLeft: theme.spacing(0.5),
        },
    },
});
export const tankWrapperStyle = (theme, transportSelectedItem, isFuelTank) => {
    var _a;
    return ({
        display: 'grid',
        gap: 1,
        gridTemplateColumns: 'repeat(7, 1fr)',
        marginTop: `${theme.spacing(0)}!important`,
        '.MuiPaperProgress-root': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '@keyframes blinker': {
                '50%': {
                    opacity: '0',
                },
            },
            '.MuiPaperProgress-cover': {
                position: 'relative',
                width: '100%',
                height: '30px',
                display: 'flex',
                justifyContent: 'center',
                '.MuiPaperProgress-degrees': {
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bottom: '10px',
                    fontSize: '11px',
                    whiteSpace: 'nowrap',
                    'span:last-of-type': {
                        position: 'absolute',
                    },
                },
            },
            '.MuiPaperProgress-determinate': {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                width: '100%',
                height: '58px',
                marginBottom: theme.spacing(1),
                '.MuiTypography-root': {
                    zIndex: '1',
                    fontSize: '11px',
                },
                svg: {
                    fontSize: '34px',
                    color: theme.palette.primary.main,
                    '&[disabled]': {
                        color: alpha(theme.palette.primary.main, 0.12),
                    },
                    '&.MuiPaperProgress-colorInherit': {
                        color: theme.palette.text.secondary,
                    },
                    '&.MuiPaperProgress-colorPrimary': {
                        color: theme.palette.primary.main,
                    },
                    '&.MuiPaperProgress-colorError': {
                        color: theme.palette.error.main,
                    },
                },
            },
            '.MuiPaperProgress-status': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: '100%',
                height: '36px',
            },
            '.MuiPaperProgress-button': {
                '.MuiButtonBase-root': {
                    svg: {
                        fontSize: '18px',
                    },
                    '&.Mui-disabled': {
                        color: alpha(theme.palette.primary.main, 0.12),
                    },
                    '&.MuiIconButton-colorInherit': {
                        color: theme.palette.text.secondary,
                    },
                    '&.MuiIconButton-colorPrimary': {
                        color: theme.palette.primary.main,
                    },
                    '&.MuiIconButton-colorError': {
                        color: theme.palette.error.main,
                    },
                },
            },
        },
        '.MuiPaper-root:first-of-type': {
            display: 'grid',
            gridColumn: '1/5',
            gap: 3,
            paddingBottom: theme.spacing(1.5),
            gridTemplateColumns: `repeat(${((_a = transportSelectedItem.tank) === null || _a === void 0 ? void 0 : _a.length) || config.numberOfTank.slice(0, -1).length + (isFuelTank ? 1 : 0)}, 1fr)`,
            '.MuiPaper-sublabel': {
                position: 'absolute',
                top: '10px',
                right: '6px',
                padding: '0 6px',
                color: theme.palette.text.secondary,
            },
        },
        '.MuiPaper-root:nth-of-type(2), .MuiPaper-root:nth-of-type(3)': {
            gridColumn: '5/6',
            paddingBottom: theme.spacing(1.5),
            '@keyframes blinker': {
                '50%': {
                    opacity: '0',
                },
            },
            '.MuiPaper-label': {
                padding: theme.spacing(0),
                left: '50%',
                transform: 'translateX(-50%)',
            },
        },
        '.MuiPaper-root:nth-of-type(3)': {
            gridColumn: '6/7',
            '.MuiPaperProgress-determinate svg': {
                fontSize: '32px',
            },
        },
        '.MuiPaper-root:last-of-type': {
            display: 'grid',
            gridColumn: '7/8',
            gap: 1,
            padding: theme.spacing(0),
            border: 'none',
            borderRadius: '0',
            bgcolor: 'transparent',
        },
    });
};
export const tankStyle = (theme, transportConditionSelectedItem, key, guard_status_tank, isFuelTank) => ({
    width: '100%',
    maxWidth: '40px',
    margin: '0 auto',
    '& .MuiPaperProgress-cover': {
        '&:before': Object.assign({ content: '""', width: '90%', height: '5px', position: 'absolute', bottom: '2px', left: '5%', zIndex: '2', bgcolor: alpha(theme.palette.primary.main, 0.12), borderRadius: theme.shape.borderRadius, transform: 'rotateX(20deg)' }, (transportConditionSelectedItem.data[`dun${key + 1}`] !== config.conditions.dun.default && Object.assign({}, (Number(transportConditionSelectedItem.data[`dun${key + 1}`]) >= config.dunLimit && {
            transform: `rotateZ(70deg) rotateY(20deg)`,
            bottom: '0',
            transformOrigin: '100% 50%',
            bgcolor: theme.palette.primary.main,
        })))),
        '& .MuiPaperProgress-degrees': Object.assign({}, (transportConditionSelectedItem.data[`dun${key + 1}`] !== config.conditions.dun.default && Object.assign({}, (Number(transportConditionSelectedItem.data[`dun${key + 1}`]) >= config.dunLimit && {
            left: '38%!important',
        })))),
    },
    '& .MuiPaperProgress-determinate': Object.assign({ bgcolor: alpha(theme.palette.primary.main, 0.12), borderRadius: theme.shape.borderRadius, '&:after': {
            content: '""',
            position: 'absolute',
            width: '100%',
            left: '0',
            bottom: '0',
            maxHeight: '100%',
            bgcolor: theme.palette.primary.main,
            height: transportConditionSelectedItem.data[`dut${key + 1}`] === config.conditions.dut.default ? '0%' : `${(Number(transportConditionSelectedItem.data[`dut${key + 1}`]) * 100) / (isFuelTank ? 3072 : 1100)}%`,
        }, '.MuiTypography-root': {
            zIndex: '1',
            fontSize: '11px',
            color: transportConditionSelectedItem.data[`dut${key + 1}`] === config.conditions.dut.default ? theme.palette.text.primary : `${(Number(transportConditionSelectedItem.data[`dut${key + 1}`]) * 100) / (isFuelTank ? 3072 : 1100) < 50 ? theme.palette.text.primary : theme.palette.primary.contrastText}`,
        } }, (transportConditionSelectedItem.data.guard_status !== config.conditions.guard_status.default && Object.assign({}, (guard_status_tank[key] !== '0' && {
        animation: 'blinker',
        animationIterationCount: 'infinite',
        animationDirection: 'linear',
        animationDuration: '600ms',
    })))),
    '& .MuiSwitch-switchBase': {
        cursor: 'default',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    '& .MuiTouchRipple-root': {
        '& .MuiTouchRipple-rippleVisible': {
            display: 'none',
        },
        '& .MuiTouchRipple-child': {
            display: 'none',
        },
    },
});
export const alarmBlockStyle = (theme) => ({
    display: 'grid',
    gap: 2,
    gridColumn: '5/8',
    padding: `${theme.spacing(0)}!important`,
    bgcolor: 'transparent',
    border: '0',
    '.MuiPaperAlert-alarm > div': {
        width: '100%',
        height: '100%',
    },
    '.MuiButton-root': {
        width: '100%',
        margin: theme.spacing(0),
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: theme.palette.divider,
        svg: {
            fontSize: '30px',
            path: {
                fill: 'currentColor',
            },
            '&[disabled]': {
                color: alpha(theme.palette.primary.main, 0.12),
            },
        },
        '&:hover, &.active, &.Mui-disabled': {
            bgcolor: 'background.paper',
            color: theme.palette.text.secondary,
        },
        '&.MuiButton-containedPrimary': {
            color: theme.palette.primary.main,
        },
        '&.MuiButton-containedError': {
            color: theme.palette.error.main,
        },
    },
});
export const signalStrengthStyle = (theme) => ({
    display: 'flex',
    alignItems: 'flex-end',
    gap: '2px',
    height: '18px',
    paddingBottom: theme.spacing(0.75),
    marginTop: theme.spacing(-0.75),
    minWidth: '50px',
    span: {
        width: '5px',
        display: 'inline-block',
        borderRadius: '2px',
    },
    'span:nth-of-type(1)': {
        height: '25%',
    },
    'span:nth-of-type(2)': {
        height: '50%',
    },
    'span:nth-of-type(3)': {
        height: '75%',
    },
    'span:nth-of-type(4)': {
        height: '100%',
    },
});
export const gsmOperatorLogoStyle = (theme) => ({
    alignSelf: 'center',
    marginLeft: theme.spacing(1),
    height: '18px',
    width: 'auto',
    display: 'block',
});
export const voltageStyle = (theme) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr fit-content(180px)',
    gap: 1,
    marginTop: `${theme.spacing(0)}!important`,
});
export const mapTransportConditionIconsListStyle = (theme) => ({
    marginLeft: '3px',
    div: {
        display: 'flex',
        marginRight: '2px',
        svg: {
            fontSize: '18px',
        },
    },
    'div:last-of-type': {
        marginRight: theme.spacing(0),
    },
});
export const paperProgressStatusStyle = () => ({
    '.MuiSwitch-root': {
        height: '18px',
        '& .MuiSwitch-track': {
            width: '24px',
            heigth: '6px',
        },
        '& .MuiSwitch-thumb': {
            width: '11px',
            height: '11px',
        },
    },
});
export const paperProgressFuelTunkStyle = (theme, transportConditionSelectedItem) => ({
    width: '50%',
    maxWidth: '40px',
    margin: '0 auto',
    '& .MuiSvgIcon-root': {
        fontSize: '29px',
        color: theme.palette.primary.main,
    },
    '& .MuiPaperProgress-cover': {
        '& .MuiPaperProgress-degrees': Object.assign({}, (transportConditionSelectedItem.data[`in5`] !== config.conditions.dun.default && Object.assign({}, (Number(transportConditionSelectedItem.data[`in5`]) >= config.dunLimit && {
            left: '38%!important',
        })))),
    },
    '& .MuiPaperProgress-determinate': {
        bgcolor: alpha(theme.palette.primary.main, 0.12),
        borderRadius: theme.shape.borderRadius,
        '&:after': {
            content: '""',
            position: 'absolute',
            width: '100%',
            left: '0',
            bottom: '0',
            maxHeight: '100%',
            bgcolor: theme.palette.primary.main,
            height: transportConditionSelectedItem.data[`in5`] === config.conditions.dut.default ? '0%' : `${(Number(transportConditionSelectedItem.data[`in5`]) * 100) / 3072}%`,
        },
        '.MuiTypography-root': {
            zIndex: '1',
            fontSize: '11px',
            color: transportConditionSelectedItem.data[`in5`] === config.conditions.dut.default ? theme.palette.text.primary : `${(Number(transportConditionSelectedItem.data[`in5`]) * 100) / 3072 < 50 ? theme.palette.text.primary : theme.palette.primary.contrastText}`,
        },
    },
});
